import React from "react";

import { ReactComponent as WIP } from "../../../Assets/Images/wip.svg";



const ServerMaintenance = () => {

  return (
    <>
      <div className="content-wrapper responsive-wrapper">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 m-auto">
            <div className="downPanel">
              <WIP className="mt-3" />
              <div className="">
                <h3>The site is under maintenance!</h3>
                <p> Please try again later</p>
              </div>
            </div>
            <div className="row mt-2 mt-3">
              <div className="col-lg-12 col-md-12 col-sm-12 mb-3 mt-5">

                <img
                  src={require('../../../Assets/Images/jcb-oil.png')}
                  className=''
                  alt='oil'
                />

              </div>
            </div>

          </div>
        </div>

      </div>
    </>
  );
};

export default ServerMaintenance;
